/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["div[_ngcontent-%COMP%]{display:flex;position:absolute;top:0;bottom:0;right:0;left:0;align-items:center;justify-content:center;height:100%}img[_ngcontent-%COMP%]{height:532px;width:710px}\n/*# sourceMappingURL=not-found.component.css.map*/"];
export { styles as styles };
